<template>
  <app-action-bar
    :menu-items="actionBarItems"
    :selected-items="computedSelectedAttachedFiles"
    :selected-items-label-path="selectedItemsLabelPath"
    data-locator="files-action-bar"
    @clear-selection="deselectAllAttachedFiles"
  >
    <app-action-bar-list-item 
      v-for="item in actionBarItems"
      :item="item"
      :key="item.name"
    >
      <ChecklistTableTaskAttachedFilesItemMenu 
        v-if="item.name === 'menu'"
        :mnemo="mnemo"
        :file="computedSelectedAttachedFiles[0]"
        :multiFiles="computedSelectedAttachedFiles"
        actionBar
      />
    </app-action-bar-list-item>
  </app-action-bar>
</template>

<script>
import { mapState } from 'vuex'

import ChecklistTableTaskAttachedFilesItemMenu from '@/project/checklist/table/ChecklistTableTaskAttachedFilesItemMenu.vue'
import { RESET_SELECTED_ATTACHED_FILE } from '@/store/modules/checklist/mutation_types'

const TRANSLATION_KEY_PREFIX = 'project.checklist.panes.ChecklistPaneFilesActionBar'
export default {
  name: 'ChecklistPaneFilesActionBar',
  components: { ChecklistTableTaskAttachedFilesItemMenu },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    selectionModel: {
      type: Array,
      default: undefined,
    },
  },
  data () {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapState('checklist', ['selectedAttachedFiles']),
    // Use store selectedAttachedFiles as default if selectionModel is not provided
    computedSelectedAttachedFiles () {
      return this.selectionModel ? this.selectionModel : this.selectedAttachedFiles
    },
    actionBarItems () {
      return [
        {
          action: () => {},
          name: 'menu',
          locatorValue: 'more-actions-button',
          title: '',
        },
      ]
    },
    selectedItemsLabelPath () {
      return `${TRANSLATION_KEY_PREFIX}.attachedFileCount`
    },
  },
  methods: {
    deselectAllAttachedFiles () {
      if (this.selectionModel) {
        this.$emit('input', [])
      } else {
        this.$store.commit(`checklist/${RESET_SELECTED_ATTACHED_FILE}`)
      }
    },
  },
}
</script>

